export const JOINT_POSITION_SLIDER_VISIBILITY_EVENT =
  "selected-joint-position-slider-visibility-changed";

export function dispatchJointPositionSliderVisibility(visible: boolean): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(JOINT_POSITION_SLIDER_VISIBILITY_EVENT, {
      detail: { visible },
    })
  );
}
